import React, { useState, useEffect } from "react";
import Cart from "./Cart";
import InvoiceProdList from "./InvoiceProdList";
import Summary from "./Summary";
import { useDispatch, useSelector } from "react-redux";
import { fetchAllProduct } from "../../redux/features/product.features";
import {
  addSales,
  addToCart,
  addTotalInvoiceAmount,
  clearInvoice,
  fetchAllSales,
  addNewSalestoLocal,
  updateInvoiceStatus,
  addEditedSalesToLocal,
  updateSales,
  clearEditInvoice,
  removeAllItemFromCart,
  addToCartEditedInvoice,
  removeAllItemFromCartEditedInvoice,
  addEditedInvoice,
} from "../../redux/features/sales.features";
import { v4 as uuidv4 } from "uuid";
import Modal from "../../components/modal/Modal";
import { Box } from "@mui/system";
import InvoiceViewer from "./InvoiceViewer";
import store from "../../redux/store";
import CustomSelectBox from "../../components/CustomSelectBox/CustomSelectBox";
import { Checkbox, TextField } from "@mui/material";

import Table from "../../components/table/Table";
import { fetchAllCustomers } from "../../redux/features/customer.features";
import InvoiceTable from "./InvoiceTable";
import { MobileDatePicker } from "@mui/lab";
import converter from "number-to-words";

import { fetchAlltrips } from "../../redux/features/trip.features";
import * as moment from "moment";
import LoadingScreen from "../LoadingScreen/LoadingScreen";
import IndividualInvoiceViewer from "./IndividualInvoiceViewer";
import InvoiceTableEditInvoice from "./InvoiceTableEditInvoice";
import { fetchAllBrokers } from "../../redux/features/broker.features";
import { fetchAllbanks } from "../../redux/features/bank.features";


const banksDetails = [
  {
    id: "BANK-0",
    bankName: "INDUSTRIAL AND COMMERCIAL BANK OF CHINA (ASIA) LTD.",
  
    bankCode: "072",
    accountName: "RELIANCE TRADES",
    accountNo: "701-056-004455",
    swiftCode: "UBHKHKHH",
    bankAddress:'34/F ICBC TOWER, 3 GARDEN ROAD, CENTRAL, HONG KONG. S.A.R',

    status: "Active",
  },
  {
    id: "BANK-1",
    bankName: "CITIBANK(HONG KONG) LTD",

    bankAddress:
      "3/F, CITI TOWER, ONE BAY, EAST, 83, HOI BUN ROAD, KWUN TONG, HONG KONG",

    bankCode: "250",
    accountName: "GEM CO INTL LTD.",
    accountNo: "390-5130-5267",
    swiftCode: "CITIHKAX",
    status: "Active",
  },
  {
    id: "BANK-2",
    bankName: "EVOLVE",
    accountName: "MOHAMED RIZAN MOHAMED",
    routingNo: "08400-9519",
    accountNo: "960-000-9670-436-267",
    status: "Active",
  },
  {
    id: "BANK-3",
    bankName: "OUTSIDE US",
    accountName: "MOHAMED RIZAN MOHAMED",
    accountNo: "83124-888-26",
    swiftCode: "CMFGU33",
    bankAddress: "30 W.26 STREET, SIX FLOOR, NEW YORK, NY ,10010",

    status: "Active",
  },
  {
    id: "BANK-4",
    bankName: "BANK OF CEYLON PLC",
    accountName: "SHIMLA GEMS",
    accountNo: "914-12-15",
    swiftCode: "BCEYLKLX",
    bankAddress: "1, BOC SQUARE, BANK OF CEYLON MAWATHA, COLOMBO 01, SRI LANKA",
    status: "Active",
  },
];
const initialState = {
  invoiceCreatedDate: new Date().toUTCString(),
  invoiceType: "Sales", //sales/onApprovals
  invoiceCategory: "Visit", //visit , online, local
  invoiceSubCategory: "", //select trips
  invoiceCurrency: "USD",
  invoiceShipmentStatus: "Delivered On the Visit",
  invoicePaymentType: "Bank Transfer",
  invoiceStatus: "NotApproved",

  invoiceCustomer: [],
  invoiceBanks: [],

  invoiceSubTotal: 0.0,
  invoiceDiscountAmount: 0.0,
  invoiceSubTotalAfterDiscount: 0.0,
  invoiceGrandTotal: 0.0,

  invoiceExtraCharges: 0.0,
  invoiceTotalAmountReceived: 0.0,
  invoiceBalanceToReceived: 0.0,
  invoiceBalanceToCustomer: 0.0,
};

const EditInvoice = (props) => {
  let salesState = useSelector((state) => {
    return state.salesReducer;
  });

  let { recentInvoice, EditInvoice, sales, successMessage, errorMessage } =
    salesState;
  let { invoiceItemList } = EditInvoice;

  const [cart, setCart] = useState([]);
  const [tab, setTab] = useState(1);
  const [showLoading, setShowLoading] = useState(false);
  const [filteredCustomers, setfilteredCustomers] = useState([]);
  const [filteredBrokers, setfilteredBrokers] = useState([]);
  const [values, setValues] = useState(EditInvoice);
  const [resetKey, setResetKey] = useState(uuidv4());
  const [showItemDetails, setShowItemDetails] = useState(false);
  const [showInvoiceAddingModal, setShowInvoiceAddingModal] = useState(false);
  const [showInvoiceViewerModal, updateInvoiceViewerShowModal] =
    useState(false);
  const [showIndividualInvoiceViewerModal, setIndividualInvoiceShow] =
    useState(false);
  const [selectedInvoice, setselectedInvoice] = useState(false);
  const [showInvoiceList, setShowInvoiceList] = useState(false);
  // const [selectedBanks, setSetSelectedBanks] = useState([]);
  // const [selectedBanksIds, setSetSelectedBanksIds] = useState([]);
  const [saveClicked, setsaveClicked] = useState(false);
  const [onCreateClicked, setonCreateClicked] = useState(false);
  const [selectedCurrency, setSelectedCurrency] = useState(
    EditInvoice.invoiceCurrency
  );

  const toggleItemDetails = () => setShowItemDetails((state) => !state);
  const toggleInvoiceModal = () =>
    updateInvoiceViewerShowModal((state) => !state);

  let dispatch = useDispatch();

  useEffect(() => {
    dispatch(fetchAllCustomers());
    dispatch(fetchAllBrokers());
  }, [dispatch]);

  useEffect(() => {
    dispatch(fetchAllbanks());
  }, [dispatch]);

  let bankState = useSelector((state) => {
    return state.bankReducer;
  });
  let { banks } = bankState;


  let productState = useSelector((state) => {
    return state.productReducer;
  });
  let userState = useSelector((state) => {
    return state.userReducer;
  });

  let customerState = useSelector((state) => {
    return state.customerReducer;
  });
  let brokerState = useSelector((state) => {
    return state.brokerReducer;
  });

  let tripState = useSelector((state) => {
    return state.tripReducer;
  });

  let { trips } = tripState;
  let { customers } = customerState;
  let { brokers } = brokerState;

  let { products, loading } = productState || { products: [], loading: false };
  let { user } = userState;

  const mappingSelectedBanksIds = () => {
    let ids = [];
    if(EditInvoice && EditInvoice.invoiceBanks)
    EditInvoice.invoiceBanks.map((x) => ids.push(x.id));
    return ids;
  };

  const [availableItems, setAvailableItems] = useState([]);
  const [selectedBanks, setSetSelectedBanks] = useState(
    EditInvoice.invoiceBanks || []
  );
  const [selectedBanksIds, setSetSelectedBanksIds] = useState(
    mappingSelectedBanksIds,
    []
  );

  useEffect(() => {
    let arr = JSON.parse(JSON.stringify(products));
    let tempArr = [];
    arr.map((x) => {
      if (!x.isSold) {
        x.checked = false;
        tempArr.push(x);
      }
    });
    setAvailableItems(tempArr);
  }, [products]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    console.log(name, value);

    if (name === "invoiceTotalAmountReceived") {
      setValues({
        ...values,
        ["invoiceTotalAmountReceived"]: value, //GT - 350 recived 500 blnc 500 -350
        ["invoiceBalanceToReceived"]:
          values.invoiceGrandTotal <= Number(value || 0)
            ? 0
            : values.invoiceGrandTotal - Number(value || 0),
        ["invoiceBalanceToCustomer"]:
          values.invoiceGrandTotal <= value
            ? value - values.invoiceGrandTotal
            : 0,
      });
    } else {
      setValues({
        ...values,
        [name]: value,
      });
    }

    if (name === "invoiceCurrency") setSelectedCurrency(value);

    setsaveClicked(false);
  };
  const handleCustomerSearch = (e) => {
    const { name, value } = e.target;
    setfilteredCustomers(filterItems(value, customers));
    setsaveClicked(false);
  };
  const handleBrokerSearch = (e) => {
    const { name, value } = e.target;
    setfilteredBrokers(filterItems(value, brokers));
    setsaveClicked(false);
  };

  useEffect(() => {
    console.log("recent invoice changes happen");
    setTimeout(() => {
      setShowLoading(false);
    }, 2000);
  }, [recentInvoice]);

  const filterItems = (keyword, array) => {
    let query = keyword.toLowerCase();

    return array.filter((item) =>
      user.role === "admin"
        ? item.firstName.toLowerCase().indexOf(query) >= 0
        : item.customerId.toLowerCase().indexOf(query) >= 0
    );
  };

  const reset = () => {
    console.log("on Reset key pressed");
    setResetKey(uuidv4());

    dispatch(clearEditInvoice());
    setShowLoading(false);
    setTab(1);
    setValues(initialState);
    props?.onClose()
  };

  const onCreate = () => {
    setShowLoading(true);
    console.log("update sale", values)
    dispatch(updateSales(values));
    setonCreateClicked(true);
  };

  const onRestore = () => {
    // setShowLoading(true);
    let filteredInvoice = sales.filter(x=>x.invoiceNumber === values.invoiceNumber)[0];
    console.log("onRestore ",filteredInvoice )
    dispatch(addEditedInvoice(filteredInvoice));
     
  };



  useEffect(() => {
    if (onCreateClicked) {
      if (successMessage !== "") {
        console.log("successmessage recived");
        setTimeout(() => {
          reset();
          props.cancel();
          console.log("props cancel called");
        }, 2000);
      }
    }
  }, [onCreateClicked, successMessage]);

  const addAllItemsBulk = (data) => {
    dispatch(addToCartEditedInvoice(data));
  };
  const removeAllItemsBulk = () => {
    dispatch(removeAllItemFromCartEditedInvoice());
  };

  // useEffect(() => {
  //   if (onCreateClicked) {
  //     if (successMessage !== "") {
  //       console.log("successmessage recived");
  //       setTimeout(() => {
  //         reset();
  //         props.cancel();
  //         console.log("props cancel called");
  //       }, 2000);
  //     }
  //   }
  // }, [onCreateClicked, successMessage]);

  const validate = () => {
    var currentTab = tab;
    if (currentTab == 1) {
      //empty check
      if (values.invoiceType === "")
        return alert("Invoice type cannot be empty");
      if (values.invoiceCreatedDate === "")
        return alert("Invoice date cannot be empty");
      if (values.invoiceCategory === "")
        return alert("Invoice category cannot be empty");
      if (values.invoiceCurrency === "")
        return alert("Invoice currency cannot be empty");
      if (values.invoicePaymentType === "")
        return alert("Invoice payment method cannot be empty");
      if (values.invoiceStatus === "")
        return alert("Invoice status cannot be empty");
      //validation
      if (values.invoiceType !== "Sales" && values.invoiceCurrency !== "LKR")
        return alert("OnApproval using LKR currency only");
      if (
        values.invoiceCategory === "Visit" &&
        values.invoiceSubCategory === ""
      )
        return alert(
          "Invoice sub category cannot be empty, Select which Trip/Visit"
        );
    } else if (currentTab == 2) {
      if (values.invoiceType === "Sales" && values.invoiceCustomer.length === 0)
        return alert(
          "Invoice customer cannot be empty, please select a customer"
        );
      if (values.invoiceType !== "Sales" && values.invoiceBroker.length === 0)
        return alert(
          "OnApproval cannot be save without broker details, please select a valid broker"
        );
    }

    return true;
  };

  const onDraft = () => {
    console.log("final values", values.invoicePaymentType);
    if (tab == 4) {
      //empty check
      if (values.invoiceSubTotal === "" || values.invoiceSubTotal === 0)
        return alert("Invoice cannot save without items");
      if (
        values.invoiceSubTotalAfterDiscount === "" ||
        values.invoiceSubTotalAfterDiscount === 0
      )
        return alert("Invoice cannot save without items");
      if (values.invoiceGrandTotal === "" || values.invoiceGrandTotal === 0)
        return alert("Invoice cannot save without items");
      if (
        values.invoicePaymentType === "Credit" &&
        (values.invoiceBalanceToReceived === "" ||
          values.invoiceBalanceToReceived === 0)
      )
        return alert(
          "Selected payment type is Credit, 'InvoiceBalanceToReceived' cannot be Zero (0)"
        );
      if (
        values.invoicePaymentType === "Cash" &&
        (values.invoiceTotalAmountReceived === "" ||
          values.invoiceTotalAmountReceived === 0)
      )
        return alert(
          "Selected payment type is Cash, 'Total Amount Received' cannot be Zero (0)"
        );
      if (values.invoiceGrandTotal === "" || values.invoiceGrandTotal === 0)
        return alert("Invoice cannot save without items");
    }

    //asigning
    values.invoiceBanks = JSON.parse(JSON.stringify(selectedBanks));
    values.invoiceDate = moment(values.invoiceDate).format();
    values.invoiceCreatedDate = moment(values.invoiceCreatedDate).format();

    console.log("invoice complete", values);
    dispatch(addEditedSalesToLocal(values));

    setsaveClicked(true);
  };

  useEffect(() => {
    dispatch(fetchAllProduct());
  }, [dispatch]);

  useEffect(() => {
    dispatch(fetchAllSales());
  }, [dispatch]);

  useEffect(() => {
    dispatch(fetchAlltrips());
  }, [dispatch]);
  //invoice Table
  const onViewInvoice = (item) => {
    setselectedInvoice(item);
    setIndividualInvoiceShow(true);
  };
  // const changeToComplete = (id) => {
  //   const data = {
  //     id,
  //     invoiceStatus: "Complete",
  //   };
  //   dispatch(updateInvoiceStatus(data));
  // };

  // const onClickEditedInvoice = (data) => {
  //   let copyObj = {};
  //   for (let i in data) {
  //     copyObj[i] = data[i];
  //   }
  //   // dispatch(addEditedInvoice(copyObj));
  //   // setShowInvoiceEditingModal(true);
  // };
  //customer Table
  const customerTableHead = [
    "customer ID",
    "firstName",
    "lastName",
    "homeAddress",
    "email",
    "country",
    "status",
  ];

  const renderCustomerHead = (item, index) => <th key={index}>{item}</th>;

  const selectedCustomer = (item) => {
    console.log("selected customers ==>", item.firstName);
    if (item.status !== "Active")
      return alert(
        "Cannot select De-Active Customers, Please select Active Customers"
      );

    let arr = [];
    arr.push(item);
    setValues({ ...values, ["invoiceCustomer"]: arr });

    // store.dispatch(addStepThree(arr))
  };
  const selectedBroker = (item) => {
    console.log("selected broker ==>", item.firstName);
    let arr = [];
    arr.push(item);
    setValues({ ...values, ["invoiceBroker"]: arr });

    // store.dispatch(addStepThree(arr))
  };
  const renderCustomerBody = (item, index) => {
    let selectedCustomerStore =
      store.getState().productReducer.stepThree.customer;
    return (
      <tr
        className={
          selectedCustomerStore &&
          selectedCustomerStore.filter((x) => x.id === item.id).length !== 0
            ? "selected"
            : ""
        }
        onClick={() => selectedCustomer(item)}
        key={index}
      >
        <td>{item.customerId}</td>
        <td>{user.role === "admin" ? item.firstName : "**********"}</td>
        <td>{user.role === "admin" ? item.lastName : "**********"}</td>
        <td>{user.role === "admin" ? item.homeAddress : "**********"}</td>
        <td>{user.role === "admin" ? item.email : "**********"}</td>
        <td>{user.role === "admin" ? item.country : "**********"}</td>
        <td>
          {String(item.status).toLowerCase() === "active" ? (
            <p className="p-1 py-2 bg-green-500 rounded">{item.status}</p>
          ) : (
            <p className="p-1 py-2 bg-red-700 rounded">{item.status}</p>
          )}
        </td>
      </tr>
    );
  };

  const renderBrokerBody = (item, index) => {
    let selectedCustomerStore =
      store.getState().productReducer.stepThree.customer;
    return (
      <tr
        className={
          selectedCustomerStore &&
          selectedCustomerStore.filter((x) => x.id === item.id).length !== 0
            ? "selected"
            : ""
        }
        onClick={() => selectedBroker(item)}
        key={index}
      >
        {/* <td>{item.id}</td> */}
        <td>{item.firstName}</td>
        <td>{item.lastName}</td>
        <td>{item.homeAddress}</td>
        <td>{item.email}</td>
        <td>{item.country}</td>
        <td>
          {String(item.status).toLowerCase() === "active" ? (
            <p className="p-1 py-2 bg-green-500 rounded">{item.status}</p>
          ) : (
            <p className="p-1 py-2 bg-red-700 rounded">{item.status}</p>
          )}
        </td>
      </tr>
    );
  };
  const InvoiceCustomerList = ({ filteredCustomers }) => (
    <div className="w-full overflow-x-scroll p-4">
      <Table
        limit="5"
        headData={customerTableHead}
        renderHead={(item, index) => renderCustomerHead(item, index)}
        bodyData={filteredCustomers}
        renderBody={(item, index) => renderCustomerBody(item, index)}
      />
    </div>
  );
  const InvoiceBrokerList = ({ filteredBrokers }) => (
    <div className="w-full overflow-x-scroll p-4">
      <Table
        limit="5"
        headData={customerTableHead}
        renderHead={(item, index) => renderCustomerHead(item, index)}
        bodyData={filteredBrokers}
        renderBody={(item, index) => renderBrokerBody(item, index)}
      />
    </div>
  );

  //function calculate subtotal
  function calculateSubTotal() {
    let totalInvoiceAmount = 0.0;
    let totalForeignInvoiceAmount = 0.0;

    /// implement the price variant logic for price calculation
    for (let x of invoiceItemList || []) {
      totalForeignInvoiceAmount += Number(
        x?.priceVariant === "true"
          ? x.sellPriceForeigners2
          : x.sellPriceForeigners
      );
      totalInvoiceAmount +=
        x?.priceVariant === "true"
          ? Number(x.sellPriceLocal2)
          : Number(x.sellPriceLocal);

      console.log(totalInvoiceAmount.toFixed(2));
    }

    return selectedCurrency === "LKR"
      ? totalInvoiceAmount
      : totalForeignInvoiceAmount;
  }

  function calculateGrandTotal(grandtotal, invoiceDis) {
    return (
      calculateSubTotal() +
      Number(grandtotal || values.invoiceExtraCharges || 0) -
      Number(invoiceDis || values.invoiceDiscountAmount || 0)
    );
  }

  const summaryOnChange = (e) => {
    const { name, value } = e.target;
    if (name === "invoiceDiscountAmount") {
      setValues({
        ...values,
        ["invoiceSubTotalAfterDiscount"]:
          values.invoiceSubTotal - Number(value === "" ? 0 : value),
        ["invoiceDiscountAmount"]: value,
        ["invoiceGrandTotal"]: calculateGrandTotal(
          values.invoiceExtraCharges,
          value
        ),
        ["invoiceBalanceToReceived"]:
          values.invoicePaymentType === "Credit"
            ? calculateGrandTotal(values.invoiceExtraCharges, value)
            : 0.0,
      });
      let invoicetotal = 0;
      if (
        invoiceItemList &&
        invoiceItemList.length !== 0 &&
        invoiceItemList.filter(
          (x) => x.itemDiscountAmount && x.itemDiscountAmount !== 0
        ).length !== 0
      ) {
        alert(
          "Cannot change discount amount here, change discount amount in items"
        );
        invoiceItemList
          .filter((x) => x.itemDiscountAmount && x.itemDiscountAmount !== 0)
          .map((x) => {
            invoicetotal += x.itemDiscountAmount;
          });

        setValues({
          ...values,
          ["invoiceDiscountAmount"]: invoicetotal,
          ["invoiceSubTotalAfterDiscount"]:
            calculateSubTotal() - Number(invoicetotal),
          ["invoiceGrandTotal"]: calculateGrandTotal(
            values.invoiceExtraCharges,
            invoicetotal
          ),
          ["invoiceBalanceToReceived"]:
            values.invoicePaymentType === "Credit"
              ? calculateGrandTotal(values.invoiceExtraCharges, invoicetotal)
              : 0.0,
        });
      }
    }
    if (name === "invoiceExtraCharges") {
      setValues({
        ...values,
        ["invoiceExtraCharges"]: value,
        ["invoiceGrandTotal"]: calculateGrandTotal(value),
        ["invoiceBalanceToReceived"]:
          values.invoicePaymentType === "Credit"
            ? calculateGrandTotal(value)
            : 0.0,
      });
    }
    setsaveClicked(false);
  };

  // calculating total + grand total in useEffect
  useEffect(() => {
    setsaveClicked(false);

    let invoicetotal = 0;
    if (
      invoiceItemList &&
      invoiceItemList.length !== 0 &&
      invoiceItemList.filter(
        (x) => x.itemDiscountAmount && x.itemDiscountAmount !== 0
      ).length !== 0
    ) {
      console.log("item discount added found");
      invoiceItemList
        .filter((x) => x.itemDiscountAmount && x.itemDiscountAmount !== 0)
        .map((x) => {
          invoicetotal += x.itemDiscountAmount;
        });
      setValues({
        ...values,
        ["invoiceDiscountAmount"]: invoicetotal,
        ["invoiceSubTotal"]: calculateSubTotal(),
        ["invoiceSubTotalAfterDiscount"]:
          calculateSubTotal() - Number(invoicetotal),
        ["invoiceGrandTotal"]: calculateGrandTotal(
          values.invoiceExtraCharges,
          invoicetotal
        ),
        ["invoiceBalanceToReceived"]:
        (values.invoicePaymentType === "Credit"  || values.invoicePaymentType ===  "Bank Transfer")
            ? calculateGrandTotal(values.invoiceExtraCharges, invoicetotal)
            : 0.0,
        ["invoiceTotalAmountReceived"]: 0.0,
      });
    } else {
      setValues({
        ...values,
        ["invoiceSubTotalAfterDiscount"]:
          calculateSubTotal() - Number(values.invoiceDiscountAmount),
        ["invoiceSubTotal"]: calculateSubTotal(),
        ["invoiceGrandTotal"]: calculateGrandTotal(),
        ["invoiceBalanceToReceived"]:
          (values.invoicePaymentType === "Credit"  || values.invoicePaymentType ===  "Bank Transfer")? calculateGrandTotal() : 0.0,
        ["invoiceTotalAmountReceived"]: 0.0,
      });
    }
  }, [invoiceItemList, selectedCurrency]);

  const handleCheckboxChange = (event) => {
    const id = event.target.name;

    setSetSelectedBanksIds((currentSelectedBanksIds) => {
      if (currentSelectedBanksIds.includes(id)) {
        setSetSelectedBanks(selectedBanks.filter((f) => f.id !== id));
      } else {
        let arr = banks.filter((x) => x.id === id);

        setSetSelectedBanks((state) => [...state, arr[0]]); //adding
        console.log("adding");
      }

      return currentSelectedBanksIds.includes(id)
        ? currentSelectedBanksIds.filter((f) => f !== id)
        : //removing
          [...currentSelectedBanksIds, id]; //adding
    });
  };

  const Tab = ({ title, icon, activeIndex, index, onClick }) => (
    <div
      onClick={onClick}
      className="flex items-center p-3 mx-2 font-extrabold uppercase cursor-pointer bg-slate-500 hover:bg-slate-800"
      style={{
        boxShadow: "var(--box-shadow)",
        backgroundColor:
          activeIndex === tab ? "var(--main-color)" : "rgb(120 116 139 /1",
        color: activeIndex === tab ? "#fff" : "rgb(100 116 139 /1",
      }}
    >
      {icon} {title}
    </div>
  );

  useEffect(() => {
    console.log("selected currency changed", selectedCurrency);
    setsaveClicked(false);
  }, [selectedCurrency]);

  return (
    <>
      {showLoading ? (
        <LoadingScreen
          onClose={() => setShowLoading(false)}
          errorMessage={errorMessage}
          reset={() => reset()}
          successMessage={successMessage}
        />
      ) : (
        <div className="flex flex-col w-full h-full ">
          <div className="flex mb-2">
            {tab !== 1 && (
              <div
                onClick={() => {
                  if (validate()) setTab(tab === 0 ? tab : tab - 1);
                }}
                style={{ backgroundColor: "var(--main-color-red)" }}
                className="bx bxs-arrow-from-right bg-gray-500 p-5 font-extrabold cursor-pointer text-2xl  text-white"
              ></div>
            )}

            <div className="flex flex-1 justify-center">
              <Tab
                onClick={() => {
                  setTab(1);
                }}
                icon={<i className="bx bx-cog" />}
                title="invoice settings"
                activeIndex={1}
              />
              <Tab
                onClick={() => {
                  setTab(2);
                }}
                icon={<i className="bx bx-user" />}
                title="invoice customer"
                activeIndex={2}
              />
              <Tab
                onClick={() => {
                  setTab(3);
                }}
                icon={<i className="bx bxs-bank" />}
                title="Bank Details"
                activeIndex={3}
              />
              <Tab
                onClick={() => {
                  setTab(4);
                }}
                icon={<i className="bx bx-receipt" />}
                title="Edit Invoice"
                activeIndex={4}
              />
            </div>
            {tab !== 4 && (
              <div
                onClick={() => {
                  if (validate()) setTab(tab === 4 ? tab : tab + 1);
                }}
                style={{ backgroundColor: "var(--main-color)" }}
                className="bx bxs-arrow-from-left  p-5 font-extrabold cursor-pointer text-2xl text-white"
              ></div>
            )}
          </div>
          <div className="flex-1 border border-red-400"></div>

          {tab === 1 && (
            <div
              style={{
                background: "var(--main-bg)",
                boxShadow: "var(--box-shadow)",
              }}
              className="flex my-5 p-5 items-center"
            >
              <div className="flex justify-evenly w-full my-4">
                <div className="flex flex-wrap">
                  <div className="flex flex-col w-full">
                    <div className="flex items-center justify-between p-1 font-extrabold  mx-1 uppercase">
                      <p className="w-9/12">Invoice Date :</p>
                      <MobileDatePicker
                        label="Date mobile"
                        inputFormat="dd/MM/yyyy"
                        value={values.invoiceCreatedDate}
                        onChange={(selectedDate) => {
                          console.log("selected date", selectedDate);
                          setValues({
                            ...values,
                            ["invoiceCreatedDate"]: selectedDate,
                          });
                        }}
                        renderInput={(params) => <TextField {...params} />}
                      />
                    </div>
                  </div>
                  <div className="flex flex-col w-full">
                    <div className="flex items-center justify-between p-1 font-extrabold  mx-1 uppercase">
                      <p className="w-9/12">Invoice Type :</p>
                      <CustomSelectBox
                        onChange={handleChange}
                        items={["Sales", "OnApproval"]}
                        title="Invoice Type"
                        name="invoiceType"
                        value={values.invoiceType}
                      />
                    </div>
                  </div>
                  <div className="flex flex-col w-full">
                    <div className="flex items-center justify-between p-1 font-extrabold  mx-1 uppercase">
                      <p className="w-9/12">Invoice Category :</p>
                      <CustomSelectBox
                        onChange={handleChange}
                        items={["Visit", "Online", "Local"]}
                        title="Invoice Category"
                        name="invoiceCategory"
                        value={values.invoiceCategory}
                      />
                    </div>
                  </div>
                  <div className="flex flex-col w-full">
                    <div className="flex items-center justify-between p-1 font-extrabold  mx-1 uppercase">
                      <p className="w-9/12">Invoice Sub Category :</p>

                      <CustomSelectBox
                        onChange={handleChange}
                        items={(trips || []).map((x) => {
                          return x.tripName;
                        })}
                        title="Select Visit"
                        name="invoiceSubCategory"
                        value={values.invoiceSubCategory}
                      />
                    </div>
                  </div>
                </div>
                <div className="flex flex-wrap">
                  <div className="flex flex-col w-full">
                    <div className="flex items-center justify-between p-1 font-extrabold  mx-1 uppercase">
                      <p className="w-9/12">Invoice Currency :</p>

                      <CustomSelectBox
                        onChange={handleChange}
                        items={["USD", "LKR"]}
                        title="Invoice Currency"
                        name="invoiceCurrency"
                        value={values.invoiceCurrency}
                      />
                    </div>
                  </div>
                  <div className="flex flex-col w-full">
                    <div className="flex items-center justify-between p-1 font-extrabold  mx-1 uppercase">
                      <p className="w-9/12">Invoice Shipment Status :</p>

                      <CustomSelectBox
                        onChange={handleChange}
                        items={[
                          "Complete",
                          "Cancel",
                          "PendingShipment",
                          "Return",
                          "Delivered On the Visit",
                        ]}
                        title="Invoice Shipment Status"
                        name="invoiceShipmentStatus"
                        value={values.invoiceShipmentStatus}
                      />
                    </div>
                  </div>
                  <div className="flex flex-col w-full">
                    <div className="flex items-center justify-between p-1 font-extrabold  mx-1 uppercase">
                      <p className="w-9/12">Invoice Payment Type :</p>
                      <CustomSelectBox
                        onChange={handleChange}
                        items={[
                          "Cash",
                          "Credit",
                          "Cheque",
                          "Card",
                          "Bank Transfer",
                        ]}
                        title="Invoice Payment Type"
                        name="invoicePaymentType"
                        value={values.invoicePaymentType}
                      />
                    </div>
                  </div>
                  <div className="flex flex-col w-full">
                    <div className="flex items-center justify-between p-1 font-extrabold  mx-1 uppercase">
                      <p className="w-9/12">Invoice Status :</p>

                      <CustomSelectBox
                        onChange={handleChange}
                        items={[
                          "Complete",
                          "Cancel",
                          "NotApproved",
                          "PaymentPending",
                          "Return",
                        ]}
                        title="Invoice Status"
                        name="invoiceStatus"
                        value={values.invoiceStatus}
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          )}
          {tab === 2 && (
            <div className="flex flex-col w-full my-5 p-5">
              {values.invoiceType !== "Sales" ? (
                <div>
                  {values.invoiceBroker && values.invoiceBroker.length !== 0 ? (
                    <div className="flex items-center">
                      Selected Broker :
                      <p className="mx-3 p-3 font-extrabold text-xl ">
                        <i className="p-3 font-extrabold  bx bx-user-check"></i>
                        {values.invoiceBroker[0].firstName}
                      </p>
                      <div
                        onClick={() =>
                          setValues({ ...values, ["invoiceBroker"]: null })
                        }
                        className="mx-3 cursor-pointer bx bx-trash p-3 bg-red-500 text-white font-extrabold hover:bg-red-700"
                      ></div>
                    </div>
                  ) : (
                    <div className="flex flex-col justify-center">
                      <div
                        style={{ marginBottom: 50 }}
                        className="flex p-3 m-5 justify-start items-center"
                      >
                        <i className="bx bx-user p-2"></i>
                        Search Broker
                        <input
                          className="m-2 p-2 rounded text-black"
                          onChange={handleBrokerSearch}
                        ></input>
                      </div>

                      <hr></hr>
                      <InvoiceBrokerList filteredBrokers={filteredBrokers} />
                    </div>
                  )}
                </div>
              ) : (
                <div>
                  {values.invoiceCustomer &&
                  values.invoiceCustomer.length !== 0 ? (
                    <div className="flex items-center">
                      Selected Customer :
                      <p className="mx-3 p-3 font-extrabold text-xl ">
                        <i className="p-3 font-extrabold  bx bx-user-check"></i>
                        {user.role === "admin"
                          ? values.invoiceCustomer[0].firstName
                          : values.invoiceCustomer[0].customerId}
                      </p>
                      <div
                        onClick={() => {
                          setValues({ ...values, ["invoiceCustomer"]: null });
                          console.log("customer removed ");
                        }}
                        className="mx-3 cursor-pointer bx bx-trash p-3 bg-red-500 text-white font-extrabold hover:bg-red-700"
                      ></div>
                    </div>
                  ) : (
                    <div className="flex flex-col justify-center">
                      <div
                        style={{ marginBottom: 50 }}
                        className="flex p-3 m-5 justify-start items-center"
                      >
                        <i className="bx bx-user p-2"></i>
                        Search Customer
                        <input
                          placeholder={
                            user.role === "admin"
                              ? "Enter customer name"
                              : "Enter customer id"
                          }
                          className="m-2 p-2 rounded text-black"
                          onChange={handleCustomerSearch}
                        ></input>
                      </div>

                      <hr></hr>
                      <InvoiceCustomerList
                        filteredCustomers={filteredCustomers}
                      />
                    </div>
                  )}
                </div>
              )}
            </div>
          )}
          {tab === 3 && (
            <div className="flex my-5 p-5 flex-col ">
              {banks.map((x) => {
                // console.log(selectedBanksIds.filter(y=>y===x.id).length !==0)
                return (
                  <div
                    key={x.id}
                    className="flex font-extrabold text-2xl p-3 w-full items-center"
                  >
                    <Checkbox
                      checked={
                        selectedBanksIds.filter((y) => y === x.id).length !== 0
                      }
                      name={x.id}
                      onClick={handleCheckboxChange}
                    ></Checkbox>
                    <div>{x.bankName}</div>
                  </div>
                );
              })}

              {/* {JSON.stringify(selectedBanksIds)} */}
              <br />
              {/* {JSON.stringify(selectedBanks)} */}
            </div>
          )}
          {tab === 4 && (
            <div
              style={{ minHeight: "calc(100vh - 5vh)" }}
              className="flex flex-col w-full my-5 p-5"
            >
              <div className="flex justify-between items-start ">
                <div className="flex w-full">
                  <InvoiceTableEditInvoice
                    selectedCurrency={selectedCurrency}
                  />
                </div>
              </div>
              <div className="flex p-4 items-center border border-red-400 mt-3">
                <div className="flex items-center justify-start w-full">
                  <div
                    onClick={() => {
                      setShowInvoiceAddingModal((state) => !state);

                      setsaveClicked(false);
                    }}
                    className="p-3 text-white uppercase text-3xl  font-extrabold bg-green-600 hover:bg-green-800 cursor-pointer items-center flex "
                  >
                    <i className="p-3 bx text-white bx-list-plus"></i>
                    Add Item
                  </div>
                </div>
                <div className="flex items-center justify-center  w-full">
                  <div
                    onClick={() => {
                      addAllItemsBulk(availableItems);
                    }}
                    className="p-3 text-white uppercase text-3xl  font-extrabold bg-green-600 hover:bg-green-800 cursor-pointer items-center flex "
                  >
                    <i className="p-3 bx text-white bx-list-plus"></i>
                    Add All Available Item
                  </div>
                  <div className="p-3 font-extrabold ">
                    {" "}
                    ( {availableItems && availableItems.length} )
                  </div>
                </div>
                <div className="flex items-center justify-end  w-full">
                  <div
                    onClick={() => {
                      removeAllItemsBulk();
                    }}
                    className="p-3 text-white uppercase text-3xl  font-extrabold bg-red-600 hover:bg-red-800 cursor-pointer items-center flex "
                  >
                    <i className="p-3 bx text-white bx-list-plus"></i>
                    Remove All Item
                  </div>
                  <div className="p-3 font-extrabold ">
                    {" "}
                    ( {invoiceItemList && invoiceItemList.length} )
                  </div>
                </div>
              </div>

              <div className="flex w-full font-extrabold uppercase py-4 text-2xl">
                <h1>Sales Summary</h1>
              </div>

              <div className="flex justify-evenly w-full my-4">
                <div className="flex flex-wrap">
                  <div className="flex flex-col w-full">
                    <div className="flex items-center justify-between p-1 font-extrabold  mx-1 uppercase">
                      <p className="w-9/12">sub total :</p>
                      <TextField
                        inputProps={{ style: { textAlign: "right" } }}
                        name="invoiceSubTotal"
                        value={values.invoiceSubTotal}
                        className="w-3/12 text-right rounded"
                      />
                    </div>
                  </div>
                  <div className="flex flex-col w-full">
                    <div className="flex items-center justify-between p-1 font-extrabold  mx-1 uppercase">
                      <p className="w-9/12">discount Amount :</p>
                      <TextField
                        inputProps={{ style: { textAlign: "right" } }}
                        onChange={summaryOnChange}
                        name="invoiceDiscountAmount"
                        value={values.invoiceDiscountAmount}
                        className="w-3/12 rounded text-right"
                      />
                    </div>
                  </div>
                  <div className="flex flex-col w-full">
                    <div className="flex items-center justify-between p-1 font-extrabold  mx-1 uppercase">
                      <p className="w-9/12">sub total after Dis :</p>
                      <TextField
                        inputProps={{ style: { textAlign: "right" } }}
                        aria-readonly
                        name="invoiceSubTotalAfterDiscount"
                        value={values.invoiceSubTotalAfterDiscount}
                        className="w-3/12 rounded text-right"
                      />
                    </div>
                  </div>
                  <div className="flex flex-col w-full">
                    <div className="flex items-center justify-between p-1 font-extrabold  mx-1 uppercase">
                      <p className="w-9/12">Extra Charges :</p>
                      <TextField
                        inputProps={{ style: { textAlign: "right" } }}
                        onChange={summaryOnChange}
                        name="invoiceExtraCharges"
                        value={values.invoiceExtraCharges}
                        className="w-3/12 rounded text-right"
                      />
                    </div>
                  </div>
                </div>

                <div className="flex flex-wrap ">
                  <div className="flex flex-col w-full">
                    <div className="flex items-center justify-between p-1 font-extrabold  mx-1 uppercase">
                      <p className="w-9/12">Grand Total :</p>
                      <TextField
                        inputProps={{ style: { textAlign: "right" } }}
                        name="invoiceGrandTotal"
                        value={values.invoiceGrandTotal}
                        className="w-3/12 rounded text-right"
                      />
                    </div>
                  </div>
                  <div className="flex flex-col w-full">
                    <div className="flex items-center justify-between p-1 font-extrabold  mx-1 uppercase">
                      <p className="w-9/12">Total amount received :</p>
                      <TextField
                        inputProps={{ style: { textAlign: "right" } }}
                        onChange={handleChange}
                        name="invoiceTotalAmountReceived"
                        value={Number(values.invoiceTotalAmountReceived)}
                        className="w-3/12 rounded text-right"
                      />
                    </div>
                  </div>
                  <div className="flex flex-col w-full">
                    <div className="flex items-center justify-between p-1 font-extrabold  mx-1 uppercase">
                      <p className="w-9/12">balance to received :</p>
                      <TextField
                        inputProps={{ style: { textAlign: "right" } }}
                        name="invoiceBalanceToReceived"
                        value={values.invoiceBalanceToReceived}
                        className="w-3/12 rounded text-right"
                      />
                    </div>
                  </div>
                  <div className="flex flex-col w-full">
                    <div className="flex items-center justify-between p-1 font-extrabold  mx-1 uppercase">
                      <p className="w-9/12">balance to customer :</p>
                      <TextField
                        inputProps={{ style: { textAlign: "right" } }}
                        name="invoiceBalanceToCustomer"
                        value={values.invoiceBalanceToCustomer}
                        className="w-3/12 rounded text-right"
                      />
                    </div>
                  </div>
                </div>
              </div>

              <div
                style={{
                  background: "rgb(103 195 30)",
                  background: "#dcdcdc",
                  height: "10vh",
                  boxShadow: "var(--box-shadow-dark)",
                }}
                className="h-12 flex justify-between items-center"
              >
                <div className="text-5xl px-3 flex flex-col    text-black font-extrabold">
                  <p className="px-3">
                    {Number(values.invoiceGrandTotal || 0).toLocaleString()}{" "}
                    {values.invoiceCurrency}
                  </p>
                  <i className="text-xl font-bold text-gray-800 px-3">
                    {converter.toWords(Number(values.invoiceGrandTotal))} only
                  </i>
                </div>
                <div className="flex text-2xl text-white font-extrabold">
                  <div
                    onClick={() => reset()}
                    style={{
                      cursor: "pointer",
                      boxShadow: "var(--box-shadow-dark)",
                    }}
                    className="m-2 flex items-center rounded uppercase p-4 text-3xl hover:bg-pink-400 bg-pink-700"
                  >
                    cancel
                  </div>
                  {!saveClicked ? (
                    <div className="flex ">

                    
                    <div
                      onClick={onRestore}
                      style={{
                        cursor: "pointer",
                        boxShadow: "var(--box-shadow-dark)",
                      }}
                      className="m-2 flex items-center rounded uppercase p-4 text-3xl bg-white hover:bg-white-900  text-black "
                    >
                      Restore
                    </div>
                    <div
                      onClick={onDraft}
                      style={{
                        cursor: "pointer",
                        boxShadow: "var(--box-shadow-dark)",
                      }}
                      className="m-2 flex items-center rounded uppercase p-4 text-3xl bg-white hover:bg-white-900  text-black "
                    >
                      draft
                    </div>
                    </div>
                  ) : (
                    <>
                      {!onCreateClicked && (
                        <div
                          onClick={() => setIndividualInvoiceShow(true)}
                          style={{
                            cursor: "pointer",
                            boxShadow: "var(--box-shadow-dark)",
                          }}
                          className="m-2 flex items-center rounded uppercase p-4 text-3xl hover:bg-blue-900 bg-blue-500"
                        >
                          view
                        </div>
                      )}
                      <div
                        style={{
                          cursor: "pointer",
                          boxShadow: "var(--box-shadow-dark)",
                        }}
                        onClick={onCreate}
                        className="m-2 flex items-center rounded uppercase p-4 text-3xl bg-green-500 hover:bg-green-900 "
                      >
                        Update
                      </div>
                    </>
                  )}
                </div>
              </div>
            </div>
          )}
          {/* {tab === 5 && <div className="flex my-5 p-5">{invoiceList()}</div>} */}

          {/* <Modal
            modal_title={"INVOICE VIEWER"}
            canShow={showInvoiceViewerModal}
            updateModalState={() => {
              toggleInvoiceModal();
            }}
          >
            <Box>
              <InvoiceViewer />
            </Box>
          </Modal> */}
          <Modal
            modal_title={"INVOICE VIEWER"}
            canShow={showIndividualInvoiceViewerModal}
            updateModalState={() => {
              setIndividualInvoiceShow(false);
            }}
          >
            <Box>
              <IndividualInvoiceViewer invoice={EditInvoice} />
            </Box>
          </Modal>

          <Modal
            modal_title={"CHOOSE ITEMS"}
            canShow={showInvoiceAddingModal}
            updateModalState={() => {
              setShowInvoiceAddingModal((state) => !state);
            }}
          >
            <div>
              <InvoiceProdList mod = "edit" onClose={() => {
              setShowInvoiceAddingModal((state) => !state);
            }} invoiceCurrency={values.invoiceCurrency} />
            </div>
          </Modal>
        </div>
      )}
    </>
  );
};

export default EditInvoice;
